var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-audio-shadow-span",style:(_vm.styleObj)},[(_vm.showBanner)?_c('i',{staticClass:"-banner"},[_vm._v("Insert")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }